export const isFallbackFlyer = imageUrl =>
  imageUrl.search('//storage.googleapis.com/proton-showflyers/default-album-banner-') !==
  -1;
